/**
 * @generated SignedSource<<c6369d8b897e4c8041382526ff052a92>>
 * @relayHash 0332778beb81b5189cec62a7fd95f3a9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0332778beb81b5189cec62a7fd95f3a9

import { ConcreteRequest } from 'relay-runtime';
export type CreateDoc2USessionInput = {
  appointmentId: string;
  emailContact: string;
};
export type useCreateDoc2USessionMutation$variables = {
  input: CreateDoc2USessionInput;
};
export type useCreateDoc2USessionMutation$data = {
  readonly createDoc2USession: {
    readonly roomDoc2UOutput: {
      readonly appEndpoint: string;
      readonly practitionerTokenKey: string;
    } | null;
  };
};
export type useCreateDoc2USessionMutation = {
  response: useCreateDoc2USessionMutation$data;
  variables: useCreateDoc2USessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDoc2USessionPayload",
    "kind": "LinkedField",
    "name": "createDoc2USession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RoomDoc2UOutput",
        "kind": "LinkedField",
        "name": "roomDoc2UOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appEndpoint",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "practitionerTokenKey",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateDoc2USessionMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCreateDoc2USessionMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "0332778beb81b5189cec62a7fd95f3a9",
    "metadata": {},
    "name": "useCreateDoc2USessionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0175c7439b00d5df50fc63d66d8e87a1";

export default node;
